import { useState, useEffect } from "react";
import { Box, Typography, Tooltip, IconButton, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseOffer } from "./UseOffer";
import { useRecoilState } from "recoil";
import { rsProgress } from "../../../RecoilStates";
import CustomPagination from "../../../components/CustomPagination";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import DeleteRow from "../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";

export default function ProductsGrid(props) {
  const {
    deleteOfferProduct,
    UpdateOfferProduct,
    UpdateOffers,
    UpdateOffersData,
  } = UseOffer();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [searchSubGroup, setSearchSubGroup] = useState("");
  const [filt, setFilt] = useState([]);
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    setFilt([
      {
        columnField: "productName",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const newFunc = () => {
    return navigate("/ProductOffers/AddProduct", {
      state: {
        search: searchSubGroup,
        OfferID: props.OfferID,
        thisOfferId: props.thisOfferId,
      },
    });
  };

  const funcRefList = () => {
    setProgress(true);
    UpdateOffers(() => props.callback());
  };

  const funcRefData = () => {
    setProgress(true);
    UpdateOffersData(props.OfferID, () => props.callback());
  };

  const columns = [
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "id",
      width: 70,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "productID",
      width: 75,
      align: "center",
      headerName: "شماره",
      headerAlign: "center",
    },
    {
      field: "productName",
      headerName: "نام محصول",
      width: 300,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.productName}
          </Typography>
        );
      },
    },
    {
      field: "brand",
      headerName: "برند",
      width: 130,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.brand}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 140,
      headerAlign: "center",
      align: "left",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="حذف">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.productName,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex - 1,
                };
                if (cellValues.row.rowIndex - 1 == 0) {
                  return;
                } else {
                  UpdateOfferProduct(model, () => props.callback());
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex + 1,
                };
                if (cellValues.row.rowIndex + 1 == props.rows.length + 1) {
                  return;
                } else {
                  UpdateOfferProduct(model, () => props.callback());
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" sx={{}} />
            </IconButton>
          </>
        );
      },
    },
    {
      field: "search",
      width: 220,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <TextField
            placeholder="جستجو محصول"
            size="small"
            variant="outlined"
            value={searchSubGroup}
            inputProps={{ "aria-label": "search" }}
            onChange={(evt) => {
              setSearchSubGroup(evt.target.value);
            }}
          />
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem", mb: 5 }}>
      <DataGrid
        className="ltr-grid"
        filterModel={{
          items: filt,
        }}
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={props.rows ? props.rows : []}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={props.rows && props.rows.length ? props.rows.length : 1}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            newFunc: newFunc,
            funcRefList: funcRefList,
            funcRefData: funcRefData,
            nofab: true,
            isRefresh: true,
            isLtr: true,
            rowCount: props.rows && props.rows.length ? props.rows.length : "",
          },
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "rowIndex",
                sort: "asc",
              },
            ],
          },
        }}
      />

      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"محصول"}
        callback={() => {
          setProgress(true);
          deleteOfferProduct(deleteState.id, () => {
            props.callback();
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
